module.exports = __webpack_public_path__ + "static/media/party2.f1701d9f.jpeg";